document.addEventListener('DOMContentLoaded', function () {
  const desktopBreakpoint = 990;
  const menuItemsSelector = '.header__inline-menu .list-menu--inline > li';
  let lastItemTop = null;
  const hoverDelay = 500; // delay in ms
  const hoverTimeouts = new Map();

  if (window.innerWidth < desktopBreakpoint) {
    console.log('Custom menu script skipped on mobile');
    return;
  }

  console.log('Custom menu script loaded on desktop');

  function updateLastItemTop() {
    const menuItems = document.querySelectorAll(menuItemsSelector);
    if (menuItems.length > 0) {
      lastItemTop = menuItems[menuItems.length - 1].getBoundingClientRect().top;
    }
  }

  function attachHoverListeners() {
    const menuItems = document.querySelectorAll(menuItemsSelector);

    menuItems.forEach(item => {
      const submenu = item.querySelector('.mega-menu__content');
      if (!submenu) return;

      // Initially hide submenus
      submenu.style.visibility = 'hidden';
      submenu.style.opacity = '0';
      submenu.style.transition = 'opacity 0.2s ease';

      item.addEventListener('mouseenter', () => {
        if (hoverTimeouts.has(item)) {
          clearTimeout(hoverTimeouts.get(item));
        }

        const timeoutId = setTimeout(() => {
          const itemRect = item.getBoundingClientRect();
          const isWrapped = lastItemTop > itemRect.top + 5;

          submenu.style.marginTop = isWrapped ? '-50px' : '';
          submenu.style.zIndex = '1000';

          // Show the submenu smoothly
          submenu.style.visibility = 'visible';
          submenu.style.opacity = '1';
        }, hoverDelay);

        hoverTimeouts.set(item, timeoutId);
      });

      item.addEventListener('mouseleave', () => {
        if (hoverTimeouts.has(item)) {
          clearTimeout(hoverTimeouts.get(item));
          hoverTimeouts.delete(item);
        }

        // Instantly hide the submenu
        submenu.style.visibility = 'hidden';
        submenu.style.opacity = '0';
        submenu.style.marginTop = '';
        submenu.style.zIndex = '';
      });
    });
  }

  updateLastItemTop();
  attachHoverListeners();

  window.addEventListener('resize', () => {
    if (window.innerWidth >= desktopBreakpoint) {
      updateLastItemTop();
    }
  });
});
